import { render, staticRenderFns } from "./PageSettingsStartsPrice.vue?vue&type=template&id=134040a6&"
import script from "./PageSettingsStartsPrice.vue?vue&type=script&lang=js&"
export * from "./PageSettingsStartsPrice.vue?vue&type=script&lang=js&"
import style0 from "./PageSettingsStartsPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports